import { render, staticRenderFns } from "./WarrantyReceptionSection.vue?vue&type=template&id=721abbf1"
import script from "./WarrantyReceptionSection.vue?vue&type=script&lang=js"
export * from "./WarrantyReceptionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports